import { render, staticRenderFns } from "./historySendTable.vue?vue&type=template&id=903c47d0&"
import script from "./historySendTable.vue?vue&type=script&lang=js&"
export * from "./historySendTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports